import React, { Component } from 'react';
import Utility from '../../../Utility';
import ScrollWrapper from '../Components/ScrollWrapper';
import './WhiteboardWrapper.css';
import { connect } from 'react-redux';

// TODO: fix this code. It's kinda messed up - not happy with 'updateWhiteboardImage' routine

class WhiteboardWrapper extends Component {
	constructor(props) {
		super(props);

		this.scrollPane = React.createRef();

		this.state = {
			src: null,
			x: 0,
			paneWidth: 0,
			paneHeight: 0,
			sizedImageWidth: 0,
			sourceImage: {
				w: 0,
				h: 0
			},
			whiteboardName: ''
		};

		for (var i = props.data.visiblePresets.whiteboard.length - 1; i >= 0; i--) {
			if (props.data.visiblePresets.whiteboard[i].visible === true) {
				this.state.whiteboardName = props.data.enabledPresets.whiteboard[i].name;
				break;
			}
		}

		this.position = {
			x: null
		};

		this.pushed = 0;
	}

	componentDidMount() {
		// set timer here
		this.updateWhiteboardImage(this.props);

    	document.addEventListener('player.shiftwhiteboardleft', this.shiftWhiteboardLeft);
    	document.addEventListener('player.shiftwhiteboardright', this.shiftWhiteboardRight);
	}

	componentWillUnmount() {
    	document.removeEventListener('player.shiftwhiteboardleft', this.shiftWhiteboardLeft);
    	document.removeEventListener('player.shiftwhiteboardright', this.shiftWhiteboardRight);
	}

	shiftWhiteboardLeft = (ev) => {
		this.scrollPane.current.shift('left');
	}

	shiftWhiteboardRight = (ev) => {
		this.scrollPane.current.shift('right');
	}

	// TODO - maybe pass image / size down from above
	shouldComponentUpdate(nextProps, nextState) {
		// If the time changes, instruct whiteboard images ot update
		if (Math.round(this.props.dynamic.currentTime) !== Math.round(nextProps.dynamic.currentTime)) {
			this.updateWhiteboardImage(nextProps);
		}

		if (JSON.stringify(this.props.data.visiblePresets.whiteboard) !== JSON.stringify(nextProps.data.visiblePresets.whiteboard)) {
			var whiteboardName = '';

			for (var i = nextProps.data.visiblePresets.whiteboard.length - 1; i >= 0; i--) {
				if (nextProps.data.visiblePresets.whiteboard[i].visible === true) {
					whiteboardName = nextProps.data.enabledPresets.whiteboard[i].name;
					break;
				}
			}

			this.setState({
				whiteboardName: whiteboardName,
				sourceImage: { w: 0, h: 0 }
			});
			this.updateWhiteboardImage(nextProps);
		}

		return true;
	}

	updateWhiteboardImage(props) {
		var imageArray = null,
			imageUrl,
			visibleWhiteboard = null;

		for (var i = props.data.visiblePresets.whiteboard.length - 1; i >= 0; i--) {
			if (props.data.visiblePresets.whiteboard[i].visible === true) {
				visibleWhiteboard = props.data.enabledPresets.whiteboard[i];
				break;
			}
		}

		var sourceImage = { w: parseInt(visibleWhiteboard.width, 10), h: parseInt(visibleWhiteboard.height, 10) };

		imageArray = Utility.getThingByTime(Math.round(props.dynamic.currentTime), visibleWhiteboard.images);
		imageUrl = Utility.getImageUrl(props.data.baseImageUrl, visibleWhiteboard.prefix, imageArray[0]);

		// TODO - there could be a race condition with this function if images take a long time to load,
		// also potential Chrome bug with 304's
		var image = new Image();

		image.onload = () => {
			this.setState({ src: imageUrl, sourceImage: sourceImage });
		};

		image.src = imageUrl;
	}

	imagePreventEvents = (ev) => {
		// Firefox creates a ghost image - doing this prevents it from happening
		ev.preventDefault();
		ev.stopPropagation();
		return false;
	}

	render() {
		return(
			<div style={{ width: '100%', height: '100%' }}>
				<div className="whiteboard-toolbar">
					<div className="whiteboard-namelabel">{ this.state.whiteboardName }</div>
				</div>
				<div className="whiteboard-help whiteboard-help-resize">
					Resize using this handle.
				</div>
				<div className="whiteboard-help whiteboard-help-scroll">
					To move the board:<br />
					<span>Click + drag</span> <span className="or">or</span> <span>Shift + mouse scroll wheel</span> <span className="or">or</span> <span>Trackpad swipe</span>
				</div>
				<ScrollWrapper id="whiteboard-pane" ref={this.scrollPane} minimap={true} scrollbar={false} originalImageDimensions={this.state.sourceImage}>
					<img src={this.state.src} style={{ height: '100%' }} alt="Whiteboard" draggable="false" onDragStart={this.imagePreventEvents} />
				</ScrollWrapper>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	dynamic: state.dynamic,
});

export default connect(mapStateToProps)(WhiteboardWrapper);